"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ApiConfiguration_1 = __importDefault(require("../../utils/models/ApiConfiguration"));
var ObjectRemoveUndefined_1 = __importDefault(require("../../utils/ObjectRemoveUndefined"));
var SyncProductsMapper = /** @class */ (function () {
    function SyncProductsMapper() {
    }
    SyncProductsMapper.mapToKnownEntities = function (syncProductsCategories) {
        this._reset();
        for (var _i = 0, syncProductsCategories_1 = syncProductsCategories; _i < syncProductsCategories_1.length; _i++) {
            var syncProductsCategory = syncProductsCategories_1[_i];
            this._mapCategory(syncProductsCategory);
        }
        return {
            categories: this._categories,
            products: this._products,
            modifierGroups: this._modifierGroups,
            modifiers: this._modifiers
        };
    };
    SyncProductsMapper._reset = function () {
        this._categories = {};
        this._products = {};
        this._modifierGroups = {};
        this._modifiers = {};
    };
    SyncProductsMapper._mapCategory = function (syncProductsCategory) {
        var _a, _b;
        var _c;
        this._categories[syncProductsCategory.category_id.toString()] = ObjectRemoveUndefined_1.default.remove({
            id: syncProductsCategory.category_id.toString(),
            name: (_a = {},
                _a[ApiConfiguration_1.default.getHeader('language')] = syncProductsCategory.name,
                _a),
            description: (_b = {},
                _b[ApiConfiguration_1.default.getHeader('language')] = syncProductsCategory.description,
                _b),
            sort: syncProductsCategory.sequence,
            useFirmTimes: syncProductsCategory.use_firm_times,
            images: syncProductsCategory.images,
            subcategories: syncProductsCategory.subcategories.map(function (subCat) { return subCat.category_id; }),
            availabilities: syncProductsCategory.availabilities,
            parent_id: syncProductsCategory.parent_category_id || null,
            products: (_c = syncProductsCategory.products) === null || _c === void 0 ? void 0 : _c.map(function (product) { return product.id; })
        });
        for (var _i = 0, _d = syncProductsCategory.subcategories; _i < _d.length; _i++) {
            var subCategory = _d[_i];
            this._mapCategory(subCategory);
        }
        for (var _e = 0, _f = syncProductsCategory.products; _e < _f.length; _e++) {
            var product = _f[_e];
            this._mapProduct(product);
        }
    };
    SyncProductsMapper._mapProduct = function (syncProductsProduct) {
        var _a, _b;
        var _this = this;
        var modifierGroups = __spreadArray(__spreadArray([], syncProductsProduct.option_groups || [], true), syncProductsProduct.ingredient_groups || [], true);
        this._products[syncProductsProduct.id] = ObjectRemoveUndefined_1.default.remove({
            id: syncProductsProduct.id,
            name: (_a = {},
                _a[ApiConfiguration_1.default.getHeader('language')] = syncProductsProduct.name,
                _a),
            description: (_b = {},
                _b[ApiConfiguration_1.default.getHeader('language')] = syncProductsProduct.description,
                _b),
            featured: syncProductsProduct.featured,
            popular: syncProductsProduct.popular,
            sort: syncProductsProduct.sequence,
            unitInterval: syncProductsProduct.unit_interval,
            images: syncProductsProduct.images,
            modifierGroups: modifierGroups.map(function (group) { return "".concat(syncProductsProduct.id, "-").concat(group.id); }),
            price: syncProductsProduct.price,
            vatPrice: syncProductsProduct.price_vat_incl,
            unit: syncProductsProduct.unit,
            inStock: syncProductsProduct.in_stock,
            snooze: {
                start: syncProductsProduct.snooze_start,
                end: syncProductsProduct.snooze_end
            },
            weight: syncProductsProduct.weight,
            barcode: syncProductsProduct.barcode,
            package: syncProductsProduct.package,
            extraPoints: syncProductsProduct.extra_points,
            hasPromotionalPrice: syncProductsProduct.has_promotional_price,
            categoryId: syncProductsProduct.category.category_id,
            allergens: syncProductsProduct.allergenes,
            useFirmTimes: syncProductsProduct.use_firm_times,
            min: syncProductsProduct.min,
            max: syncProductsProduct.max,
            calories: syncProductsProduct.calories
        });
        modifierGroups.forEach(function (group) {
            _this._buildModifierGroup(group, syncProductsProduct.id);
        });
    };
    SyncProductsMapper._buildModifierGroup = function (group, productId) {
        if ('ingredients' in group) {
            this._buildModifierGroupFromIngredientGroup(group, productId);
            return;
        }
        this._buildModifierGroupFromOptionGroup(group, productId);
    };
    SyncProductsMapper._buildModifierGroupFromIngredientGroup = function (group, productId) {
        var _a, _b;
        var _this = this;
        this._modifierGroups[this._buildModifierGroupId(productId, group)] = {
            id: this._buildModifierGroupId(productId, group),
            type: 'selection',
            sort: group.sequence,
            name: (_a = {},
                _a[ApiConfiguration_1.default.getHeader('language')] = group.name,
                _a),
            description: (_b = {},
                _b[ApiConfiguration_1.default.getHeader('language')] = group.description,
                _b),
            isRequired: group.min_selection > 0,
            isUpsellGroup: false,
            isMultipleChoice: true,
            multipleChoiceMin: group.min_selection,
            multipleChoiceMax: group.max_selection,
            multipleChoiceMultiselectMax: group.multi_max,
            multipleChoiceInterval: 1,
            modifiers: group.ingredients.map(function (ingredient) { return _this._buildModifierId(_this._buildModifierGroupId(productId, group), ingredient); })
        };
        group.ingredients.forEach(function (ingredient) { return _this._buildModifierFromIngredientOrOption(ingredient, _this._buildModifierId(_this._buildModifierGroupId(productId, group), ingredient)); });
    };
    SyncProductsMapper._buildModifierGroupFromOptionGroup = function (group, productId) {
        var _a, _b;
        var _this = this;
        this._modifierGroups[this._buildModifierGroupId(productId, group)] = {
            id: this._buildModifierGroupId(productId, group),
            type: 'selection',
            sort: group.sequence,
            name: (_a = {},
                _a[ApiConfiguration_1.default.getHeader('language')] = group.name,
                _a),
            description: (_b = {},
                _b[ApiConfiguration_1.default.getHeader('language')] = group.description,
                _b),
            isRequired: true,
            isUpsellGroup: false,
            isMultipleChoice: false,
            multipleChoiceMin: null,
            multipleChoiceMax: null,
            multipleChoiceMultiselectMax: null,
            multipleChoiceInterval: null,
            modifiers: group.options.map(function (option) { return _this._buildModifierId(_this._buildModifierGroupId(productId, group), option); })
        };
        group.options.map(function (option) { return _this._buildModifierFromIngredientOrOption(option, _this._buildModifierId(_this._buildModifierGroupId(productId, group), option)); });
    };
    SyncProductsMapper._buildModifierFromIngredientOrOption = function (ingredientOrOption, modifierId) {
        var _a, _b;
        this._modifiers[modifierId] = {
            id: modifierId,
            isDefault: ingredientOrOption.selected,
            isLocked: false,
            sort: 0,
            inStock: ingredientOrOption.in_stock,
            name: (_a = {},
                _a[ApiConfiguration_1.default.getHeader('language')] = ingredientOrOption.name,
                _a),
            description: (_b = {},
                _b[ApiConfiguration_1.default.getHeader('language')] = ingredientOrOption.description || '',
                _b),
            price: ingredientOrOption.price,
            snooze: {
                start: ingredientOrOption.snooze_start,
                end: ingredientOrOption.snooze_end
            },
            images: ingredientOrOption.image ? [{ main: true, thumb: ingredientOrOption.image, detail: ingredientOrOption.image }] : [],
            ingredientType: 'type' in ingredientOrOption ? ingredientOrOption.type : '',
            type: 'ingredient_group_id' in ingredientOrOption ? 'ingredient' : 'option',
            allergens: []
        };
    };
    SyncProductsMapper._buildModifierGroupId = function (productId, group) {
        return "".concat(productId, "-").concat(group.id.toString());
    };
    SyncProductsMapper._buildModifierId = function (modifierGroupId, modifier) {
        return "".concat(modifierGroupId, "-").concat(modifier.id.toString());
    };
    SyncProductsMapper._categories = {};
    SyncProductsMapper._products = {};
    SyncProductsMapper._modifierGroups = {};
    SyncProductsMapper._modifiers = {};
    return SyncProductsMapper;
}());
exports.default = SyncProductsMapper;
